export default __webpack_public_path__ + "img/sound.f1ec7bd2.svg";